export enum FileType {
  CUSTOM_GEOJSON = "custom_geojson",
}
